import {  UserEntityDeleteData, UserListParams, UserRelationData } from '@/types/users';
import httpClient from './http-client';
import DeviceService from './devices';
import CustomerService from './customers';



export default class UserService {
    private baseApiEndpoint = '/api/usrs';
    private idToken: string | undefined = '';
    private accessToken: string | undefined = '';

    constructor(idToken?: string | undefined, accessToken?: string | undefined) {
        this.idToken = idToken;
        this.accessToken = accessToken;
        this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
                                ? '' : this.baseApiEndpoint;
        // this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
        //                         ? '' : this.baseApiEndpoint;
        // this.customerApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
        //                         ? '' : this.customerApiEndpoint;
    }

    async getDetails(): Promise<any> {

        const USE_MOCK_MODE = import.meta.env.VITE_USE_MOCK_USER_DATA === 'true';
  
        if (USE_MOCK_MODE) {
            try {
            const response = await fetch('/mockUser.json');
            if (!response.ok) {
                throw new Error('Failed to load mock user data from /mockUser.json');
            }
            const mockUserData = await response.json();
            return mockUserData;
            } catch (error) {
            console.error('Error loading mock user data:', error);
            throw new Error('Mock mode enabled but failed to load /mockUser.json. Please ensure the file exists in the public folder.');
            }
        }
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/users`,
                {},
                {
                    headers: {
                         'X-Id-Authorization': this.idToken,
                         'X-Authorization': `Bearer ${this.accessToken}`,
                         'Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error fetching user details:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async getPermissions(userID?: any): Promise<any> {
        let response;
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/users/permissions?user_id=${userID}&request_id=${new Date().getTime()}`,
                {
                    headers: {
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                        // 'X-Id-Authorization': this.idToken,
                         'Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error fetching user details:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    /**
     * Fetch paginated list of users with optional filtering
     */
    async getUsers(params: UserListParams = {}): Promise<any> {
        try {
            const response = await httpClient.get(`${this.baseApiEndpoint}/users`, {
                params: {
                    page: params.page || 1,
                    size: params.size || 10,
                    search: params.search || undefined,
                    role_id: params.role_id || undefined,
                    sort_by: params.sort_by || undefined,
                    sort_order: params.sort_order || undefined
                },
                headers: {
                    // 'X-Authorization': `Bearer ${this.accessToken}`,
                    // 'X-Id-Authorization': this.idToken,
                     'Authorization': `Bearer ${this.accessToken}`,
                },
            });
            return response?.data || null;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    }

    /**
     * Fetch all available roles
     */
    async getRoles(): Promise<any> {
        try {
            console.log(this.baseApiEndpoint)
            const response = await httpClient.get(`${this.baseApiEndpoint}/users/roles`, {
                headers: {
                    // 'X-Authorization': `Bearer ${this.accessToken}`,
                    // 'X-Id-Authorization': this.idToken,
                     'Authorization': `Bearer ${this.accessToken}`
                },
            });
            return response?.data || null;
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        }
    }

    /**
     * Update user relations (customers, sitegroups, sites)
     */
    async updateUserRelations(relationData: UserRelationData): Promise<any> {
        try {
            const response = await httpClient.put(`${this.baseApiEndpoint}/users/relations`, relationData, {
                headers: {
                    // 'X-Authorization': `Bearer ${this.accessToken}`,
                    // 'X-Id-Authorization': this.idToken,
                     'Authorization': `Bearer ${this.accessToken}`,
                },
            });
            return response?.data || null;
        } catch (error) {
            console.error('Error updating user relations:', error);
            throw error;
        }
    }

    /**
     * Delete user entities
     */
    async deleteUserEntities(entityData: UserEntityDeleteData): Promise<any> {
        try {
            const response = await httpClient.delete(`${this.baseApiEndpoint}/users/entities`, {
                data: entityData,
                headers: {
                    // 'X-Authorization': `Bearer ${this.accessToken}`,
                    // 'X-Id-Authorization': this.idToken,
                     'Authorization': `Bearer ${this.accessToken}`,
                },
            });
            return response?.data || null;
        } catch (error) {
            console.error('Error deleting user entities:', error);
            throw error;
        }
    }

    // Customer-related methods

    /**
     * Fetch site groups
     */
   

    /**
     * Update user permissions
     */
    async updatePermissions(permissionData: any): Promise<any> {
        try {
            const response = await httpClient.put(`${this.baseApiEndpoint}/users/permissions`, permissionData, {
                headers: {
                    // 'X-Authorization': `Bearer ${this.accessToken}`,
                    // 'X-Id-Authorization': this.idToken,
                     'Authorization': `Bearer ${this.accessToken}`,
                },
            });
            return response?.data || null;
        } catch (error) {
            console.error('Error updating user permissions:', error);
            throw error;
        }
    }
}

// Export individual functions for easy consumption
export const fetchUsersAPI = async (params: UserListParams = {}, idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    return await userService.getUsers(params);
};

export const fetchRolesAPI = async (idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    return await userService.getRoles();
};





export const fetchCustomerDetailsAPI = async (customerAccountId: number, idToken?: string, accessToken?: string) => {
    const customerService = new CustomerService(idToken, accessToken);
    const data = await customerService.getCustomerDetails(customerAccountId);
    
    if (data && Array.isArray(data)) {
        return data;
    } else if (data?.sites && Array.isArray(data.sites)) {
        return data.sites;
    } else {
        return [];
    }
};

export const assignSitesToUserAPI = async (userId: number, siteIds: string[], idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    const relationData: UserRelationData = {
        user_id: userId,
        site_ids: siteIds.map(siteId => parseInt(siteId))
    };
    return await userService.updateUserRelations(relationData);
};

export const updateUserRelationsAPI = async (userId: number, assignedCustomers: any[], assignedSiteGroups: any[], assignedSites: any[], idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    const relationData: UserRelationData = {
        user_id: userId
    };

    if (assignedCustomers.length > 0) {
        relationData.customer_ids = assignedCustomers.map(customer => customer.id);
    }

    if (assignedSiteGroups.length > 0) {
        relationData.sitegroup_ids = assignedSiteGroups.map(siteGroup => siteGroup.id);
    }

    if (assignedSites.length > 0) {
        relationData.site_ids = assignedSites.map(site => parseInt(site.site_id));
    }

    return await userService.updateUserRelations(relationData);
};

export const deleteUserEntitiesAPI = async (entityIds: number[], entityType: string, userId: number, idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    const entityData: UserEntityDeleteData = {
        entity_ids: entityIds,
        entity_type: entityType,
        user_id: userId
    };
    return await userService.deleteUserEntities(entityData);
};

export const getUserDetailsAPI = async (idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    return await userService.getDetails();
};

export const getUserPermissionsAPI = async (userID?: any, idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    return await userService.getPermissions(userID);
};

export const updateUserPermissionsAPI = async (permissionData: any, idToken?: string, accessToken?: string) => {
    const userService = new UserService(idToken, accessToken);
    return await userService.updatePermissions(permissionData);
};

// Export types for use in components
export type {
    UserListParams,
    UserRelationData,
    UserEntityDeleteData
};